module.exports = __webpack_public_path__ + "static/media/45.2ee62ca8.jpg";